/**
 * @generated SignedSource<<ccd78f2080beb1287ce839bf35b8e503>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPublicProfileRespLayout_viewer$data = {
  readonly publicProfile: {
    readonly userId: string | null;
    readonly username: string | null;
    readonly walletAddress: {
      readonly address: string | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"NftPublicProfileMedia_publicProfile">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"NftProfileCollection_viewer" | "NftPublicProfileInfo_viewer" | "useHasMinterRole_viewer" | "useNftProfileOwner_viewer">;
  readonly " $fragmentType": "NftPublicProfileRespLayout_viewer";
};
export type NftPublicProfileRespLayout_viewer$key = {
  readonly " $data"?: NftPublicProfileRespLayout_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPublicProfileRespLayout_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "username"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftPublicProfileRespLayout_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "username",
          "variableName": "username"
        }
      ],
      "concreteType": "PublicProfile",
      "kind": "LinkedField",
      "name": "publicProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "username",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "EthereumAddressType",
          "kind": "LinkedField",
          "name": "walletAddress",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "address",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NftPublicProfileMedia_publicProfile"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftProfileCollection_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftPublicProfileInfo_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useHasMinterRole_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useNftProfileOwner_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "26ee74f7554c8ce58ae31c4ef25e8a48";

export default node;
